import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressBarMode } from '../../types/progress-bar-mode';

@Component({
  selector: 'app-progress-bar',
  imports: [ProgressBarModule],
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent {
  public readonly size = input('6px');
  public readonly mode = input<ProgressBarMode>('indeterminate');
  public readonly value = input<number>(0);
}
